// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Toaster } from 'sonner';
import './i18n/i18n.ts';
import { CircleCheck } from 'lucide-react';
import './styles/tailwind.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Toaster
      position='top-center'
      icons={{
        success: <CircleCheck className='text-green-500' size={18} />,
      }}
    ></Toaster>
  </React.StrictMode>,
);
